import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import React from 'react';
import i18n from 'i18n-js';
import ModalBase from './ModalBase';
import CancelButton from "./CancelButton";
import BasicButton from "./BasicButton";

export default function ModalConfirm({ showModal, closeModal, title, text, options, buttonOk, buttonCancel }) {

    return (
        <ModalBase showModal={showModal}>
            <Text className="text-2xl leading-2xl text-secondary-900">{i18n.t(title)}</Text>
            <Text className="text-lg leading-xl text-secondary-900">{i18n.t(text, options)}</Text>
            <VStack space='md' className="pt-3 w-[100%]">
                <BasicButton bg='bg-error-600' onPress={() => { closeModal(true) }} text={i18n.t(buttonOk || 'modalDeleteAccount.delete')} />
                {buttonCancel != '' && <CancelButton onPress={() => { closeModal(false); }} text={i18n.t(buttonCancel || 'modalDeleteAccount.cancel')} />}
            </VStack>
        </ModalBase>
    );
}